import { App } from 'vue'
import CheckboxGroup from './LpCheckboxGroup.vue'
import MultiSelect from './LpMultiselect.vue'

const checkboxgroup = {
  CheckboxGroup,
  MultiSelect,
}

for (const elem in checkboxgroup) {
  if (checkboxgroup.hasOwnProperty(elem)) {
    // @ts-ignore
    const element = checkboxgroup[elem]
    element.install = (Vue: App) => {
      Vue.component(element.name, element)
    }
  }
}

export default checkboxgroup
